import { Reveal } from "./Reveal";

const PORTRAIT = "/assets/portrait.webp";

export const About = () => (
  <section id="o-mnie" data-testid="about-section" className="py-24 lg:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-start gap-14 px-4 sm:px-8 lg:grid-cols-12 lg:gap-20 lg:px-16">
      <div className="lg:col-span-7">
        <Reveal>
          <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#8C6D46]">
            O mnie
          </p>
          <h2 className="font-serif text-2xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-3xl lg:text-4xl">
            Łączę nieruchomości, biznes i&nbsp;proces inwestycyjny
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-base leading-relaxed text-slate-600 sm:text-lg">
            Od ponad 20 lat działam w biznesie, sprzedaży i zarządzaniu. Prowadziłem własne firmy
            i placówki handlowe działające zarówno w modelu własnym, franczyzowym, jak i agencyjnym.
            Realizowałem również inwestycje deweloperskie i budowlane.
          </p>
          <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
            Przez dwa lata pełniłem funkcję burmistrza miasta i gminy, dzięki czemu znam proces
            inwestycyjny również od strony administracji samorządowej, planowania przestrzennego
            i procedur. Dziś wykorzystuję to doświadczenie, pomagając przedsiębiorcom i inwestorom
            w realizacji projektów nieruchomościowych.
          </p>
        </Reveal>
      </div>

      <Reveal className="lg:col-span-5" delay={0.15}>
        <div className="relative">
          <div className="absolute -left-4 -top-4 h-full w-full rounded-sm border border-[#8C6D46]/40" />
          <img
            src={PORTRAIT}
            alt="Janusz Błotnicki"
            data-testid="about-portrait-image"
            className="relative aspect-[4/5] w-full rounded-sm object-cover object-[30%_center]"
          />
          <div className="absolute -bottom-6 -right-4 bg-[#090D16] px-7 py-5 sm:-right-6">
            <p className="font-serif text-3xl font-medium text-[#D8B07C]">20+</p>
            <p className="mt-1 text-[11px] uppercase tracking-[0.18em] text-white/60">lat w biznesie</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
